const periodNumbers = {
  First: 1,
  Second: 2
};

const semesters = [
  { id: periodNumbers.First, name: "Primer" },
  { id: periodNumbers.Second, name: "Segundo" }
];

export { periodNumbers, semesters };
